<template>
  <div class="managingPeople hp100 bbox " v-loading="loading">
    <!-- 卡片视图 -->
    <el-card>
      <!-- 搜索-->
      <el-row :gutter="20" type="flex" justify="space-between">
        <!-- <el-col>
          <el-button
            plain
            class="add-column-btn bbox"
            @click="gotoDetail('')"
            type="primary"
          >
            <i class="el-icon-plus fw900 f16"></i> 新增</el-button
          >
        </el-col> -->
        <el-col>
          <div class="flex align-center  header-search-box">
<!--             
            <el-input
              placeholder="查询条件"
              clearable
              v-model="searchInput"
              class="header-search-input ml10"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                class="textblue searchBtn"
                @click="search()"
              ></el-button>
            </el-input> -->
            <el-form :inline="true" label-width="80px">
              <el-form-item label="日期 :">
                  <el-date-picker
                value-format="yyyy-MM-dd"
      v-model="dataRange"
      type="daterange"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期">
    </el-date-picker>
              </el-form-item>
               <el-form-item label="订单号 :">
                <el-input clearable placeholder="请输入" v-model="queryInfo.condition.orderId"></el-input>
              </el-form-item>
               <el-form-item label="流水单号 :">
                <el-input clearable placeholder="请输入" v-model="queryInfo.condition.daySeq"></el-input>
              </el-form-item>
                <el-form-item label="手机尾号 :">
                <el-input clearable placeholder="请输入" v-model="queryInfo.condition.recipientPhone"></el-input>
              </el-form-item>
              <el-button 
              @click="search"
              style="background:#f59a23;color:#fff;margin-left:12px">查询</el-button>
            </el-form>
          </div>
        </el-col>
      </el-row>
            <div class="center-menu">
        <div
          @click="searchBystatus(item.code)"
          :class="{
            'center-item': true,
            active: item.code === queryInfo.condition.status
          }"
          v-for="(item, i) in statusMenu"
          :key="i"
        >
          {{ item.name }}
        </div>
      </div>
      <!-- 用户列表区域 -->
      <!-- <div :style="{ height: height + 'px' }" style=" margin-top: 20px;"> -->
      <div  style=" margin-top: 20px;">
        <!-- <el-scrollbar style="height: 100%; width: 100%"> -->
          <el-row style="width: 100%">
            <el-table
            height="55vh"
            v-loading="tableLoading"
                element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.9)"
    customClass="tableLoad"
              :data="tableData"
              border
              fit
              highlight-current-row
              style="width: 100%"
              @sort-change="sortChange"
            >
              <!-- <el-table-column label="" align="center"  prop="" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.id }}</span>
                        </template>
                    </el-table-column> -->
              <!-- <el-table-column label="商家编码" align="center"  prop="商家编码" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.merchantCode }}</span>
                        </template>
                    </el-table-column> -->
              <!-- <el-table-column label="商家名称" align="center"  prop="商家名称" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.merchantName }}</span>
                        </template>
                    </el-table-column> -->
              <!-- <el-table-column
                label="1：团餐定制菜单；0或空：外卖菜单"
                align="center"
                prop="1：团餐定制菜单；0或空：外卖菜单"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.orderEntranceType }}</span>
                </template>
              </el-table-column> -->
              <el-table-column
                label="订单号"
                align="center"
                prop="订单号"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.orderId }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column
                label="用户下单时看到的订单号"
                align="center"
                prop="用户下单时看到的订单号"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.orderIdView }}</span>
                </template>
              </el-table-column> -->
              <!-- <el-table-column label="备注" align="center" prop="备注">
                <template slot-scope="scope">
                  <span>{{ scope.row.caution }}</span>
                </template>
              </el-table-column> -->
              <!-- <el-table-column label="城市Id" align="center" prop="城市Id">
                <template slot-scope="scope">
                  <span>{{ scope.row.cityId }}</span>
                </template>
              </el-table-column> -->
              <el-table-column
                label="订单创建时间"
                align="center"
                prop="订单创建时间"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.ctime | dataFormat }}</span>
                </template>
              </el-table-column>

              <el-table-column
                label="门店当天的订单流水号"
                align="center"
                prop="门店当天的订单流水号"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.daySeq }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column
                label="用户预计送达时间。即用户选择或填写的预计送达时间。“立即送达”时为0
单位:秒,"
                align="center"
                prop="用户预计送达时间。即用户选择或填写的预计送达时间。“立即送达”时为0
单位:秒,"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.deliveryTime }}</span>
                </template>
              </el-table-column> -->
              <!-- <el-table-column
                label="预计送达时间
即时单：字段值为配送系统提供的预计送达时间。

到店自取单：字段值为用户到店取餐时间。

预订单：字段值为用户下单时填写的预计送达时间。

该信息默认不推送，如有需求可联系开放平台工作人员开通"
                align="center"
                prop="预计送达时间
即时单：字段值为配送系统提供的预计送达时间。

到店自取单：字段值为用户到店取餐时间。

预订单：字段值为用户下单时填写的预计送达时间。

该信息默认不推送，如有需求可联系开放平台工作人员开通"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.estimateArrivalTime }}</span>
                </template>
              </el-table-column> -->
              <!-- <el-table-column label="订单详情" align="center" prop="订单详情">
                <template slot-scope="scope">
                  <span>{{ scope.row.detail }}</span>
                </template>
              </el-table-column> -->
              <!-- <el-table-column
                label="三方的门店Id"
                align="center"
                prop="三方的门店Id"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.ePoiId }}</span>
                </template>
              </el-table-column> -->
              <!-- <el-table-column
                label="参考【7.3.1"
                align="center"
                prop="参考【7.3.1"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.extras }}</span>
                </template>
              </el-table-column> -->
              <!-- <el-table-column
                label="是否需要发票"
                align="center"
                prop="是否需要发票"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.hasInvoiced }}</span>
                </template>
              </el-table-column> -->
              <!-- <el-table-column label="发票抬头" align="center" prop="发票抬头">
                <template slot-scope="scope">
                  <span>{{ scope.row.invoiceTitle }}</span>
                </template>
              </el-table-column> -->
              <!-- <el-table-column
                label="
发票税号"
                align="center"
                prop="
发票税号"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.taxpayerId }}</span>
                </template>
              </el-table-column> -->
              <!-- <el-table-column
                label="用户是否收藏此门店"
                align="center"
                prop="用户是否收藏此门店"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.isFavorites }}</span>
                </template>
              </el-table-column> -->
              <!-- <el-table-column
                label="用户是否第一次在此门店点餐"
                align="center"
                prop="用户是否第一次在此门店点餐"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.isPoiFirstOrder }}</span>
                </template>
              </el-table-column> -->
              <!-- <el-table-column
                label="是否第三方配送"
                align="center"
                prop="是否第三方配送"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.isThirdShipping }}</span>
                </template>
              </el-table-column> -->
              <!-- <el-table-column
                label="实际送餐地址纬度"
                align="center"
                prop="实际送餐地址纬度"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.latitude }}</span>
                </template>
              </el-table-column> -->
              <!-- <el-table-column
                label="实际送餐地址经度"
                align="center"
                prop="实际送餐地址经度"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.longitude }}</span>
                </template>
              </el-table-column> -->
              <!-- <el-table-column label="用餐人数" align="center" prop="用餐人数">
                <template slot-scope="scope">
                  <span>{{ scope.row.dinnersNumber }}</span>
                </template>
              </el-table-column> -->
              <!-- <el-table-column
                label="配送方式码"
                align="center"
                prop="配送方式码"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.logisticsCode }}</span>
                </template>
              </el-table-column> -->
              <el-table-column label="原价(元)" align="center" prop="">
                <template slot-scope="scope">
                  <span>{{ scope.row.originalPrice }}</span>
                </template>
              </el-table-column>
              <!--
              <el-table-column label="支付类型" align="center" prop="支付类型">
                <template slot-scope="scope">
                  <span>{{ scope.row.payType }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="0：普通取餐；1：到店取餐"
                align="center"
                prop="0：普通取餐；1：到店取餐"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.pickType }}</span>
                </template>
              </el-table-column>
              <el-table-column label="门店地址" align="center" prop="门店地址">
                <template slot-scope="scope">
                  <span>{{ scope.row.poiAddress }}</span>
                </template>
              </el-table-column>
              <el-table-column label="门店名称" align="center" prop="门店名称">
                <template slot-scope="scope">
                  <span>{{ scope.row.poiName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="商家电话" align="center" prop="商家电话">
                <template slot-scope="scope">
                  <span>{{ scope.row.poiPhone }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="商家对账详情"
                align="center"
                prop="商家对账详情"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.poiReceiveDetail }}</span>
                </template>
              </el-table-column> -->
              <el-table-column
                label="脱敏收货人地址"
                align="center"
                prop="脱敏收货人地址"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.recipientAddress }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="脱敏收货人地址"
                align="center"
                prop="脱敏收货人地址"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.recipientAddressDesensitization }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="收货人姓名"
                align="center"
                prop="收货人姓名"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.recipientName }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="收货人电话"
                align="center"
                prop="收货人电话"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.recipientPhone }}</span>
                </template>
              </el-table-column>
              <el-table-column label="订单状态" align="center" prop="订单状态">
                <template slot-scope="scope">
                  <span v-if=" scope.row.status ==1">用户已提交订单</span>
                  <span v-if=" scope.row.status ==2">可推送到App方平台也可推送到商家</span>
                  <span v-if=" scope.row.status ==4">商家已确认</span>
                  <span v-if=" scope.row.status ==6">已配送</span>
                  <span v-if=" scope.row.status ==8"> 已完成</span>
                  <span v-if=" scope.row.status ==9">已取消</span>
                </template>
              </el-table-column>
              <el-table-column label="订单总价" align="center" prop="订单总价">
                <template slot-scope="scope">
                  <span>{{ scope.row.total }}</span>
                </template>
              </el-table-column>
              <!--
              <el-table-column label="菜品份数" align="center" prop="菜品份数">
                <template slot-scope="scope">
                  <span>{{ scope.row.quantity }}</span>
                </template>
              </el-table-column> -->
              <!-- <el-table-column
                label="餐厅平均送餐时间，单位为秒"
                align="center"
                prop="餐厅平均送餐时间，单位为秒"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.avgSendTime }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="订单业务打标枚举，即业务身份。16-拼好饭场景订单，19-团餐场景订单"
                align="center"
                prop="订单业务打标枚举，即业务身份。16-拼好饭场景订单，19-团餐场景订单"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.orderTagList }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="拼好饭一起送的订单信息"
                align="center"
                prop="拼好饭一起送的订单信息"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.phf_order_extra_data }}</span>
                </template>
              </el-table-column> -->
              <!-- <el-table-column
                label="降级标识

订单数据状态标记。当订单中部分字段的数据因内部交互异常或网络等原因延迟生成（超时），导致开发者当前获取的订单数据不完整，此时平台对订单数据缺失情况进行标记。如不完整，建议尝试重新查询。注意，平台仅对部分模块的数据完整性进行监察标记（参考incmp_modules字段）。参考值：
-1：有数据降级
0：无数据降级"
                align="center"
                prop="降级标识

订单数据状态标记。当订单中部分字段的数据因内部交互异常或网络等原因延迟生成（超时），导致开发者当前获取的订单数据不完整，此时平台对订单数据缺失情况进行标记。如不完整，建议尝试重新查询。注意，平台仅对部分模块的数据完整性进行监察标记（参考incmp_modules字段）。参考值：
-1：有数据降级
0：无数据降级"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.incmpCode }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="降级模块有降级的数据模块的集合，参考值：
0：订单商品详情
1：订单优惠信息
2：商品优惠详情
3：订单用户会员信息
4：订单维度的商家对账信息
5：订单维度的商家对账信息(元)
6：订单收货人地址
7：订单配送方式
8：开放平台用户id
9：部分退款商品信息
10：退货退款物流信息
11：部分订单基本信息(包括订单优惠信息、订单商品详情、门店信息等)
12：sku信息
13：spu信息
14：商品信息(可能是sku或spu等商品相关信息获取时降级)"
                align="center"
                prop="降级模块有降级的数据模块的集合，参考值：
0：订单商品详情
1：订单优惠信息
2：商品优惠详情
3：订单用户会员信息
4：订单维度的商家对账信息
5：订单维度的商家对账信息(元)
6：订单收货人地址
7：订单配送方式
8：开放平台用户id
9：部分退款商品信息
10：退货退款物流信息
11：部分订单基本信息(包括订单优惠信息、订单商品详情、门店信息等)
12：sku信息
13：spu信息
14：商品信息(可能是sku或spu等商品相关信息获取时降级)"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.incmpModules }}</span>
                </template>
              </el-table-column> -->
              <!-- <el-table-column
                label="收餐地址行政区域"
                align="center"
                prop="收餐地址行政区域"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.addressOfReceivingAdministrative }}</span>
                </template>
              </el-table-column> -->
              <!-- <el-table-column
                label="用户下单时间"
                align="center"
                prop="用户下单时间"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.orderSendTime |dataFormat}}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="订单取消时间"
                align="center"
                prop="订单取消时间"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.logisticsCancelTime |dataFormat }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="订单完成时间"
                align="center"
                prop="订单完成时间"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.logisticsCompletedTime |dataFormat }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="配送单确认时间，骑手接单时间"
                align="center"
                prop="配送单确认时间，骑手接单时间"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.logisticsConfirmTime |dataFormat}}</span>
                </template>
              </el-table-column> -->
              <!--
              <el-table-column
                label="
骑手电话"
                align="center"
                prop="
骑手电话"
              >
               <template slot-scope="scope">
                  <span>{{ scope.row.logisticsDispatcherMobile }}</span>
                </template>
              </el-table-column>
              <el-table-column label="骑手姓名" align="center" prop="骑手姓名">
                <template slot-scope="scope">
                  <span>{{ scope.row.logisticsDispatcherName }}</span>
                </template>
              </el-table-column> -->
              <!-- <el-table-column
                label="骑手取单时间"
                align="center"
                prop="骑手取单时间"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.logisticsFetchTime }}</span>
                </template>
              </el-table-column>
              <el-table-column label="配送方ID" align="center" prop="配送方ID">
                <template slot-scope="scope">
                  <span>{{ scope.row.logisticsId }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="
配送方名称"
                align="center"
                prop="
配送方名称"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.logisticsName }}</span>
                </template>
              </el-table-column> -->
              <!-- <el-table-column
                label="配送单下单时间"
                align="center"
                prop="配送单下单时间"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.logisticsSendTime|dataFormat }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="配送订单状态code"
                align="center"
                prop="配送订单状态code"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.logisticsStatus }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="商家确认时间"
                align="center"
                prop="商家确认时间"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.orderConfirmTime|dataFormat }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="订单完成时间"
                align="center"
                prop="订单完成时间"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.orderCompletedTime|dataFormat }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="订单取消时间"
                align="center"
                prop="订单取消时间"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.orderCancelTime!=''">{{ scope.row.orderCancelTime |dataFormat}}</span>
                <span v-else>--</span>
                </template>
              </el-table-column>
              <el-table-column  label="创建时间" align="center" prop="创建时间">
                <template slot-scope="scope">
                  <span>{{ scope.row.createDt |dataFormat}}</span>
                </template>
              </el-table-column>
              <el-table-column label="修改时间" align="center" prop="修改时间">
                <template slot-scope="scope">
                  <span>{{ scope.row.updateDt |dataFormat}}</span>
                </template>
              </el-table-column> -->
              <el-table-column
                label="操作"
                align="center"
                class-name="small-padding fixed-width"
              >
                <template slot-scope="scope">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="编辑"
                    placement="bottom"
                  >
                    <i
                      class="el-icon-edit textblue f16"
                      @click="gotoDetail(scope.row.id, scope.row.userCode)"
                    ></i>
                  </el-tooltip>
                  <!-- <el-tooltip
                    class="item"
                    effect="dark"
                    content="删除"
                    placement="bottom"
                  >
                    <i
                      class="el-icon-delete textblue f16 ml20"
                      @click="del(scope.row.id)"
                    ></i>
                  </el-tooltip> -->
                </template>
              </el-table-column>
            </el-table> 
                          <div >
        <!-- 分页区域 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="queryInfo.currPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
            </el-row
        >

        <!-- </el-scrollbar> -->
      </div>
      <div class="footerBox">
        <!-- 分页区域 -->
        <!-- <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="queryInfo.currPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination> -->
      </div>
    </el-card>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  data() {
    return {
         statusMenu: [
        { name: "全部订单", code: null },
        { name: "待接单", code: 2 },
        { name: "已接单", code: 4 },
        {name:"已配送",code:6},
        { name: "已完成", code: 8 },
        { name: "已取消", code: 9 }
      ],
      dataRange:[],
      tableLoading:true,
      height: window.innerHeight - 256, //表格高度
      value: "",
      searchInput: "",
      tableData: [],
      loading: true,
      // 获取用户列表查询参数对象
      queryInfo: {
        // 当前页数
        currPage: 1,
        // 每页显示多少数据
        pageSize: 20,
        //查询条件
        condition: {
          merchantCode:localStorage.getItem('merchantCode'),
          id: "",
          status:null,
          orderId:'',
          daySeq:'',
          recipientPhone:'',
        }
      },
      userlist: [],
      total: 0,
      // 添加用户对话框
      addDialogVisible: false,
      // 用户添加
      addUserForm: {
        username: "",
        password: "",
        email: "",
        mobile: ""
      },
      // 修改用户
      editDialogVisible: false,
      editUserForm: {},
      // 分配角色对话框
      setRoleDialogVisible: false
    };
  },
  created() {
    // this.queryInfo.currPage = this.$route.query.currPage;
    // this.queryInfo.pageSize = this.$route.query.pageSize;
    var now= moment().format('YYYY-MM-DD')
    // this.$set(this,'dataRange',[now,now])
    this.dataRange[0]=now
    this.dataRange[1]=now
    this.queryInfo.condition.startDt=this.dataRange[0]
    this.queryInfo.condition.endDt=this.dataRange[1]
    this.getListData();
    window.addEventListener("resize", this.getHeight);

  },
  mounted() {
    this.loading = false;
  },
  destroyed() {
    window.removeEventListener("resize", this.getHeight);
  },
  methods: {
      searchBystatus(code) {
      console.log(code, this.queryInfo.condition);
      this.queryInfo.condition.status = code;
      this.search();
    },
    //条件查询
    search() {
      if(this.dataRange!=null && this.dataRange!=''&&this.dataRange.length!=0){
        this.queryInfo.condition.startDt=this.dataRange[0]
        this.queryInfo.condition.endDt=this.dataRange[1]
      }else{
        this.queryInfo.condition.startDt=null
        this.queryInfo.condition.endDt=null
      }
      // this.queryInfo.condition.id = this.searchInput;
      this.getListData();
    },
    // 监听 pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getListData();
    },
    // 监听 页码值 改变事件
    handleCurrentChange(newSize) {
      this.queryInfo.currPage = newSize;
      this.getListData();
    },

    // 监听排序
    sortChange() {},
    //跳转到详情
    gotoDetail(id) {
      var that = this;
      this.$router.push({
        path: "/meituanWaimaiOrder/details",
        query: {
          id: id,
          currPage: that.queryInfo.currPage,
          pageSize: that.queryInfo.pageSize
        }
      });
    },

    // 删除用户
    async del(id) {
      const confirmResult = await this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).catch(err => err);
      if (confirmResult === "confirm") {
        var that = this;
        that.$http
          .post("/meituanWaimaiOrders/delete", { id: id })
          .then(function(response) {
            that.$notify.success({
              title: "提示",
              message: "删除成功",
              showClose: true
            });
            that.getListData();
          });
      }
    },
    getListData() {
      // 获取列表
      var that = this;
      that.tableLoading=true
      that.$http
        .post("/meituanWaimaiOrders/list", that.queryInfo)
        .then(function(response) {
          console.log(response.data.data);
          that.tableLoading=false
          if (response.data.code == 200) {
            that.total = response.data.data.count;
            that.queryInfo.currPage = response.data.data.currPage;
            that.tableData = response.data.data.data;
          }
        });
    },
    // 监听表格高度
    getHeight() {
      this.height = window.innerHeight - 256;
    }
  }
};
</script>

<style lang="less" scoped>
.textblue {
  color: #008eff;
}
.managingPeople {
  .el-card {
    // height: calc(100vh - 114px);
    height: calc(100vh + 10px);
    position: relative;
    .el-select > .el-input {
      width: 200px;
    }
    .header-search-box .header-search-input {
      width: 325px;
    }
    input::placeholder {
      font-size: 12px;
    }
    .handle-btn .el-button.add-column-btn {
      width: 100%;
      font-size: 13px;
      background-color: transparent;
      color: #008eff;
      z-index: 102;
    }
    .footerBox {
      position: absolute;
      width: 100%;
      height: 78px;
      left: 20px;
      right: 20px;
      bottom: 0;
    }
  }
}
/deep/.el-scrollbar__view {
  min-width: 100%;
}
/deep/.el-scrollbar__wrap {
  overflow-x: auto;
  height: calc(100%); //多出来的20px是横向滚动条默认的样式
  width: 100%;
}
/deep/.el-scrollbar .el-scrollbar__wrap .el-scrollbar__view {
  white-space: nowrap;
  display: inline-block;
}
/deep/ .status{
  display: flex;
  flex: wrap;
  .item{
    width: 120px;
    text-align: center;
  }
  .active{
    border-bottom: 1px solid #ccc;
  }
}

.center-menu {
  display: flex;
  .center-item {
    user-select: none;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
    width: 56px;
    height: 46px;
    line-height: 46px;
    font-size: 14px;
    margin-right: 20px;
    cursor: pointer;
  }
  .center-item:hover {
    border-bottom: 2px solid rgb(255, 189, 0);
  }
  .center-item.active {
    border-bottom: 2px solid rgb(255, 189, 0);
  }
}

/deep/.el-loading-spinner .el-loading-text{
  color: rgb(255, 189, 0);
}
</style>
